import React, { useState, useEffect } from 'react'
import { Label, Input, Button, Form } from 'reactstrap'
import ProjectModal from '../../../components/Modal/ProjectModal';
import Table from '../../../components/Table'
import SuccessPopups from '../../../components/Popups/SuccessPopups';
import axios from 'axios';
import { environment } from '../../../env';
import { Link } from 'react-router-dom';
import WarningPopup from '../../../components/Popups/WarningPopup';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectAction, loaderAction, warningModalToggle } from '../../../redux/actions/Index';
import EmptyTable from '../../../components/errorComponents/EmptyTable';
import { useForm } from 'react-hook-form';
import _ from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useMemo } from 'react';
import { Eye, Trash } from '@phosphor-icons/react';
import moment from 'moment';
import PathName from '../../../components/PathName/PathName';

const Projects = () => {
    const [filterProject, setFilterProject] = useState()
    const dispatch = useDispatch();
    const projectList = useSelector((state) => state?.ModalReducer?.projectList);
    const user = useSelector((state) => state?.Reducers?.userdata);


    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm();

    var searchproject = watch('project');


    useMemo(() => {
        if (searchproject) {
            dispatch(loaderAction(true))
            const SearchUrl = `${environment.baseUrl}project-filter/?name=${searchproject}`;
            const result = axios(SearchUrl).then((res) => {
                if (res?.data?.length > 0) {
                    let data = res.data;
                    setFilterProject(res.data);
                    dispatch(loaderAction(false))
                }
                else {
                    dispatch(loaderAction(false))
                }
            })
        }
    }, [searchproject])

    useEffect(() => {
        // console.log(user)
    }, [projectList, user])

    const deleteProjectData = (id) => {
        dispatch(warningModalToggle(id));
    };

    const getProjectData = () => {
        try {
            axios.get(`${environment.baseUrl}project/`).then(res => {
                let data = res.data;
                dispatch(getProjectAction(data));

            }).catch(res => {
                console.log("error");
            })
        }
        catch (err) {
            console.log(err);
        }
    };

    const deleteData = (id) => {
        dispatch(loaderAction(true))
        dispatch(warningModalToggle(id))
        axios.delete(`${environment.baseUrl}editproject/${id}`).then(res => {
            if (res.data.code === 200) {
                getProjectData();
                dispatch(loaderAction(false))

            }
        })
            .catch(res => {
                toast.error(res?.data == undefined ? 'Internal Server Error !' : res.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 1500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: false,
                  });
                dispatch(loaderAction(false))
                console.log("error");
            })
    };


    const columns = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Address',
            selector: row => row.address1,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'City',
            selector: row => row.city.city_name,
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Total Area',
            selector: row => row.total_area_of_project + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Occupied Area',
            selector: row => row.occupied_area + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Available',
            selector: row => (row.total_area_of_project - row.occupied_area).toFixed(2) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Start Date',
            selector: row => moment(row.created_at).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.6rem",
            }
        },
        {
            name: 'Action',
            cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <Link to={`/Projects/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
                {user?.role != 'user' && <>
                    <ProjectModal button='edit' title='Edit New Projects' data={row} />
                    {user?.role == 'superadmin' && <button onClick={() => deleteProjectData(row.id)} id={row.ID} className="icon-bg-red border-0 px-2 py-3 rounded"><Trash size="28" className='icon-color-red' /></button>}
                </>}
            </div>,
        },
    ];

    return (
        <>
            <SuccessPopups />
            <PathName />
            <WarningPopup deleteData={deleteData} />
            <div className="Projects-main">
                <Form >
                    <div className='my-4 row'>
                        <div className='col-11 mx-auto mx-md-0 col-md-4 col-lg-4 col-xl-4 pb-3 pt-1'>
                            <div className='mt-1  d-flex gap-3'>
                                <select id="project" name="project" className="p-4  border-radius-10 shadow-none  w-100 fs-4 title-font-500 fs-2 modal-input"
                                    {...register("project", { required: true, onChange: (e) => { e.target.value } })}>
                                    <option value='' >Select Project</option>
                                    {projectList?.sort((a, b) => a?.name?.localeCompare(b?.name))?.map((project, i) => {
                                        return (
                                            <option value={project.name} key={i}>{project.name}</option>
                                        );
                                    })}
                                </select>
                            </div>
                            <br />
                        </div>
                    </div>
                </Form>
                <br />
                <div className="bg-white rounded-5 mb-5 shadow-sm  p-4 p-md-4 p-lg-5 p-xl-5">
                    <div >
                        <div className="d-flex justify-content-between align-items-center">
                            <h1 className='mb-5 title-font-bold '>PROJECTS</h1>
                            <ProjectModal button='create' data={projectList} />
                        </div>
                        {projectList?.[0] == undefined ? <EmptyTable /> : <Table columns={columns} data={searchproject && searchproject != '' ? filterProject : projectList} />}
                    </div>
                </div>
            </div>

        </>
    )
}

export default Projects